var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.002 16.004H8.998C7.893 16.004 6.998 15.109 6.998 14.004V10C6.998 8.895 7.893 8 8.998 8H15.003C16.108 8 17.003 8.895 17.003 10V14.004C17.002 15.108 16.107 16.004 15.002 16.004Z",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.923 20.044C18.733 19.447 19.447 18.732 20.044 17.923",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.956 6.07699C4.553 5.26699 5.268 4.55299 6.077 3.95599",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21.876C11.495 22.026 12.505 22.026 13.5 21.876",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.124C11.495 1.974 12.505 1.974 13.5 2.124",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.956 17.923C4.553 18.733 5.268 19.447 6.077 20.044",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.923 3.95599C18.733 4.55299 19.447 5.26799 20.044 6.07699",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.124 10.5C1.974 11.495 1.974 12.505 2.124 13.5",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.876 10.5C22.026 11.495 22.026 12.505 21.876 13.5",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M7.079 9.466L10.773 12.108C11.503 12.63 12.484 12.631 13.214 12.11L16.921 9.466",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvites);
export default __webpack_public_path__ + "static/media/invites.30fc0196038fac4b04a0abb5731f471f.svg";
export { ForwardRef as ReactComponent };